// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.puml_preview {
    flex: 1;
    overflow: auto;
    padding: 20px 28px;
    touch-action: none;
}

.puml_preview__loading {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.puml_preview__loading_spinner {
    width: 22px;
    height: 22px;
    border: 2px solid var(--color-text-muted);
    border-top-color: transparent;
    border-radius: 50%;
    animation: puml_preview__spin 0.7s linear infinite;
}

@keyframes puml_preview__spin {
    to { transform: rotate(360deg); }
}

.puml_preview__error {
    padding: 18px;
    font-size: 13px;
    color: var(--color-text-muted);
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/PumlPreview/s.puml_preview.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,6BAA6B;IAC7B,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC","sourcesContent":[".puml_preview {\n    flex: 1;\n    overflow: auto;\n    padding: 20px 28px;\n    touch-action: none;\n}\n\n.puml_preview__loading {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.puml_preview__loading_spinner {\n    width: 22px;\n    height: 22px;\n    border: 2px solid var(--color-text-muted);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: puml_preview__spin 0.7s linear infinite;\n}\n\n@keyframes puml_preview__spin {\n    to { transform: rotate(360deg); }\n}\n\n.puml_preview__error {\n    padding: 18px;\n    font-size: 13px;\n    color: var(--color-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
